import {ChargeParams} from '../StaxInterface';

export interface ChargePayload {
  payment_method_id: string;
  meta: {
    memo: string;
    reference: string;
    lineItems: {
      item: string;
      details: string;
      quantity: number;
      price: number;
    }[];
  };
  total: number;
  pre_auth: number;
  idempotency_id: string;
}

// Generate a unique idempotency ID for each charge attempt
const generateIdempotencyId = (invoiceId: string): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 8);
  return `${invoiceId}-${timestamp}-${random}`;
};

export const toCharge = (params: ChargeParams): ChargePayload => {
  const lineItems = [
    {
      item: 'Triple P Disposal',
      details: '',
      quantity: 1,
      price: params.basePrice,
    },
  ];

  if (params.applyServiceCharge) {
    lineItems.push({
      item: 'Card Service Charge',
      details: '',
      quantity: 1,
      price: params.total - params.basePrice,
    });
  }

  return {
    payment_method_id: params.paymentMethodId,
    meta: {
      memo: params.po || '',
      reference: params.referenceId,
      lineItems: lineItems,
    },
    total: params.total,
    pre_auth: 0,
    idempotency_id: generateIdempotencyId(params.invoiceId),
  };
};
